<template>
	<dialog-slot
			title="Customers bulk change"
			apply-text="Apply"
			isFullScreen
			@updateClose="onClose"
			@updateSave="onApply"
			:is-btn-safe="selected.length === 0"
	>

		<div class="mainSec">

			<card-slot
					title="Bulk Actions for Selected Customers"
					icon="edit"
			>
				<div class="cardSlotMain">
					<field
							margin="0"
							padding="0"
							height="24"
							:switch-value="!!frozen"
							@updateSwitch="onCheckbox($event, 'frozen')"
							label-switch="Frozen status"
							is-dense
							is-switch
							is-off-style
					></field>

				</div>
			</card-slot>
			<card-slot
					v-if="selected.length"
					:title="getTitle"
					icon="icon-ListDuties"
			>

				<div class="itemsCustomersList">
					<div class="item"
					     v-for="(item, i) in selected"
					     :key="i"
					     :class="{ frozen: Number(item.frozen) === 1 }"
					>
						<div class="num">{{ getItemNum( i ) }}</div>
						<div class="name">{{ item.customer }}</div>
						<div class="frozenStatus">Frozen status: <div class="value">{{ getOnOff(item.frozen) }}</div> </div>
					</div>
				</div>
			</card-slot>

			<card-slot
					v-if="selected.length && isFrozenTouched"
					title="Notice"
					icon="attention"
			>
				<div class="text">
					After saving, the status of these companies will be changed to
					<b>{{ Number(frozen) === 1 ? 'FROZEN' : 'UNFROZEN' }}</b>.
				</div>
			</card-slot>

		</div>

		<main-table-all-back
				v-if="customerInvoicesListCBC"
				textCreate="Add invoice"
				:flag="flag"
				page-title="Customer invoices"
				:headers="getHeaders"
				:filtersList="customerInvoicesFiltersCBC"
				:list="customerInvoicesListCBC"
				:defaultOrder="customerInvoicesOrderCBC"
				:defaultSort="customerInvoicesSortCBC"

				:totals="customerInvoicesTotalsCBC"
				:total-pages="customerInvoicesTotalCBC"
				:limit-pages="customerInvoicesLimitCBC"
				:pages="[ 20, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				:selected="selected"
				@updateList="onList"
				@updateEdit="onEdit"
				@updateRefreshFilters="onRefreshFilters"

				@updateCheckOrder="onCheckOrder($event,'customerInvoicesListCBC', 'invoice_id')"
				@updateCheckOrders="onCheckOrders($event,'customerInvoicesListCBC')"
				@updateCheckAll="onCheckAll"
				:checkAll="checkAll"
				:indeterminate="indeterminate"
				:isExport="false"
				:is-create="false"
				:is-settings="false"

				:externalRefreshKey="externalRefreshKey"
				:externalResetKey="externalResetKey"
				:externalResetMode="externalResetMode"
				:is-page-title="false"
				:is-all-filter-view="false"

		></main-table-all-back>
	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack.vue";
// import getUniqId from "@/helper/getUniqId";
import { mapActions, mapGetters } from "vuex";
import { customerInvoiceListHeaderCBC } from "@/components/Accounting/CustomerInvoices/constants";
import getUniqId from "@/helper/getUniqId";
import checkBoxOrders from "@/mixins/checkBoxOrders";
import CardSlot from "@/shared/CardSlot/CardSlot.vue";

export default {
	name: "CustomersBulkChange",
	mixins: [ checkBoxOrders ],
	components: { CardSlot, DialogSlot, MainTableAllBack },
	computed: {
		...mapGetters([
			"customerInvoicesListCBC",
			"customerInvoicesFiltersCBC",
			"customerInvoicesTotalsCBC",

			"customerInvoicesOrderCBC",
			"customerInvoicesLimitCBC",
			"customerInvoicesSortCBC",
			"customerInvoicesTotalCBC",
			//
			//
			// "invoiceFiles",
			// "activeFilters", // Получаем фильтры из Vuex
			// 'permissionsDefault',
			// "permissions",
			// "selectedInvoices",
			// "customerInvoicesPayment",
		]),
		getHeaders() {
			return customerInvoiceListHeaderCBC;
		},
		getTitle() {
			return `Selected Customers ${ this.selected.length }`;
		},

	},
	props: {
		list: {
			type: Array,
			default: function() {
				return []; 
			}
		},
	},
	data: function() {
		return {
			flag: "customersBulkChange",
			uniqId: null,
			selected: [],
			checkAll: false,
			indeterminate: false,

			externalRefreshKey: null, // Обновление списка с фильтрами
			externalResetKey: null, // Сброс фильтров
			externalResetMode: 'default', // Тип сброса фильтров ('default' сброс до дефолтніх фильтров) | ('empty' спрос всех фильтров)

			frozen: null,
			isFrozenTouched: false,
		};
	},
	watch: {
		selected: {
			deep: true,
			handler(val) {
				if (!Array.isArray(val) || !val.length) return;

				const seen = new Set();
				const unique = [];

				for (let i = 0; i < val.length; i++) {
					const item = val[i];
					const id = item && item.customer_id;
					if (id == null) continue;

					// якщо customer_id немає — можеш або пропускати, або залишати (я пропускаю дубль, але перший без id теж піде як "undefined")
					if (seen.has(id)) continue;

					seen.add(id);
					unique.push(item);
				}

				// щоб не ловити зайві цикли — оновлюємо тільки якщо реально щось змінилось
				if (unique.length !== val.length) {
					this.selected = unique;
				}
			},
		},
	},
	methods: {
		...mapActions([
			"getCustomerInvoicesCBC",
			// "getSelectedInvoices",
			"getCustomerInvoicesTotalCBC",
			// "getCustomerInvoicesPayment",
			// "onCustomerInvoicesClear",
			"getCustomerInvoicesFiltersCBC",
			// "onExportLink",
			// "onDeleteInvoice",
			// "setAlert",
			// "actionPreloader",
			// "getInvoiceFiles",
			// "getInvoiceOpen",
			// "onSelectedInvoicesClear",
			"updateActiveFilters", // Экшен для обновления фильтров
			// "resetActiveFilters", // Экшен для сброса фильтров
			// "getGenerateInvoice",
			// "onGenerateInvoice",
			"sendCustomerBulk",
		]),
		onClose: function() {
			this.$emit("updateCloseDialog");
		},
		async onApply() {
			if (!Array.isArray(this.selected) || !this.selected.length) return;

			//  Собираем customer_id
			const customerIds = [
				...new Set(
					this.selected
						.filter(item => item && item.customer_id != null)
						.map(item => item.customer_id)
				)
			];

			// Формируем payload
			const payload = {
				customer_id: customerIds,
				frozen: Number(this.frozen) === 1 ? 1 : 0,
			};

			try {
				// Отправляем
				await this.sendCustomerBulk(payload);

				// Закрываем модалку
				this.$emit("updateCloseDialog");

			} catch (e) {
				console.error('Bulk update error:', e);
			}
		},

		getOnOff(value) {
			return Number(value) === 1 ? 'ON' : 'OFF';
		},
		getItemNum(i) {
			return String(i + 1).padStart(2, '0');
		},

		onCheckbox({ value }, key) {
			// 1) выставляем значение свитчера
			if (key === 'active') {
				this[key] = value ? 1 : 0;
				return;
			}

			this[key] = value;

			// 2) bulk update для selected
			if (key === 'frozen') {
				this.isFrozenTouched = true;

				const frozenVal = value ? 1 : 0;

				this.selected = (this.selected || []).map(function(item) {
					if (!item) return item;

					// создаём копию, чтобы не мутировать объект напрямую
					return Object.assign({}, item, { frozen: frozenVal });
				});
			}
		},

		onCheckAll() {
			this.checkAll = false;
			this.indeterminate = false;
			this.selected = [];
			this.isFrozenTouched = false;
			this.frozen = null;
		},
		async onUpdateFilters(filters, isWithoutFilters) {

			// Сохраняем фильтры в Vuex
			await this.updateActiveFilters(filters);

			// Загружаем данные с учетом фильтров
			await this.getCustomerInvoicesCBC(filters);
			if (!isWithoutFilters) await this.getCustomerInvoicesFiltersCBC(filters);
			await this.getCustomerInvoicesTotalCBC(filters);

		},

		async onEvent(flag) {
			if (flag === "create") {
				this.isCustomerInvoicesCreate = true;
				this.invoiceId = null;
			}

			if (flag === "reports") {
				this.isPreloader = true;
				const { customers, service } = await this.getGenerateInvoice();
				this.customers = customers;
				this.service = service;

				if (customers && service) this.isGenerateInvoice = true;

				this.isPreloader = false;
			}
		},
		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getCustomerInvoicesCBC(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value);
			}
		},

		externalRefresh() {
			// обновить таблицу, сохранив текущие фильтры
			this.externalRefreshKey = getUniqId();
		},
		externalReset(mode) {
			// 'default' | 'empty' (default до дефолтних | empty усі фільтра)
			this.externalResetMode = mode;
			this.externalResetKey = getUniqId();
		},

		onEdit({ line }) {
			if (line.status === 'Open') {
				this.isCustomerInvoicesCreate = true;
				this.invoiceId = line['invoice_id'];
			}
		},
		onRefreshFilters() {
			this.resetActiveFilters(); // Очищаем фильтры в Vuex
			this.onCheckAll();
			this.onUpdateFilters(this.defaultFilter);
		},

		async onUpdateFiltersMod() {
			if (this.activeFilters && Object.keys(this.activeFilters).length) {
				await this.onUpdateFilters(this.activeFilters);
			} else {
				await this.onUpdateFilters();
			}
		}
	},
	async mounted() {
		console.log('%c [  mounted  ] ', 'color:#bada55' );
		await this.onUpdateFiltersMod();
	},
};
</script>

<style lang="scss" scoped>
.mainSec {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-gap: 15px;
}
.itemsCustomersList {
	.item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;
		padding: 3px 5px;
		.num {
			text-align: center;
			width: 24px;
			color: var(--base-green);
		}
		.frozenStatus {
			display: flex;
			align-items: center;
			gap: 8px;
			flex: 1;
			justify-content: flex-end;
			font-size: 13px;
			color: var(--card-color-sub-title);
			.value {
				color: var(--base-green);
			}
		}
		&:nth-child(even) {
			background-color: var(--card-bg-opacity);
		}

		&.frozen {
			.num {
				color: var(--base-orange);
			}
			.frozenStatus {
				color: var(--base-orange);
				.value {
					color: var(--base-red);
				}
			}
		}

	}

}
</style>
